import styled from "styled-components";

export const ProfileImage = styled.label`
  margin: auto;
  border-radius: 50%;
  width: 160px;
  height: 160px;
  border: 2px solid var(--success-color);
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;

  & > div:first-child {
    width: 150px;
    height: 150px;
    overflow: hidden;
    border-radius: 50%;
    pointer-events: none;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  @media (max-width: 992px) {
    width: 130px;
    height: 130px;
    & > div:first-child {
      width: 120px;
      height: 120px;
    }
  }
`;


export const EditProfileWrapper = styled.div`
  position: absolute;
  width: 33px;
  height: 33px;
  border-radius: 50%;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  bottom: 8px;
  right: 10px;


  & > div:first-child {
    background-color: var(--warning-color);
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  @media (max-width: 992px) {
    width: 24px;
    height: 24px;
    
    i {
      align-self: baseline;
    }
    
    i::before {
      font-size: .7rem;
    }
  }
`;
